// extracted by mini-css-extract-plugin
export var messageSideLeft = "_on-1";
export var messageSideRight = "_on-2";
export var orderLookupBubbleContainer = "_on-0";
export var submitButton = "_on-3";